import { TITLE_SIGN_IN } from '../../modules/constants/shared.constants';

export function buildTitle(pageTitle: string, isRapUser: boolean) {
  const title = isRapUser ? $localize`RESPONSE Road Service` : $localize`AAA Roadside Assistance`
  return `${title} - ${pageTitle ? pageTitle : TITLE_SIGN_IN()}`
}
